import { fetchQualification } from './Actions'
import { qualificationConfigSlice, initialState } from './Slice'

export { fetchQualification }
export { initialState, qualificationConfigSlice }

export default qualificationConfigSlice.reducer
